(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Change account icon click to popup
  const accountIconAnchor = document.querySelector('.header__icon--account.OpenCustomerPopupDialog');
  if (!accountIconAnchor) return;
  const handleAccountIconAnchorClick = e => {
    e.preventDefault();
    const loginDialog = document.querySelector('#CustomerLoginDialog');
    if (!loginDialog) {
      throw new Error('No login dialog found in DOM');
    };
    loginDialog.open();
  }
  accountIconAnchor.addEventListener('click', handleAccountIconAnchorClick);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-redesigned"]) return;
  try {
    
  const openPopup = (e) => {
    let { target } = e;
    if (!target.classList.contains('popupOpenner')) {
      target = target.closest('.popupOpenner');
    }
    const targetId = target.dataset.target;
    const popup = document.querySelector(`#${targetId}`);
    
    if (!popup) return;

    popup.open();

    const form = popup.querySelector('form');
    const firstInputEl = form.querySelector('input');

    if (!firstInputEl) return;
    
    firstInputEl.focus();
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    const popupOpenner = document.querySelectorAll('.popupOpenner');
    for (const trigger of popupOpenner) {
      trigger.addEventListener('click', openPopup);
    }

    // Notify after update
    (function () {
      const url = new URL(window.location.href);
      const timeout = 1000;
      const status = ToastMaker.status;
      if (url.searchParams.has('name_updated')) {
        ToastMaker.createToast(status.success, 'You successfully changed your name.');
        setTimeout(() => {
          url.searchParams.delete('name_updated');
          window.history.replaceState({}, '', url.toString());
        }, timeout);
      }
      if (url.searchParams.has('address_updated')) {
        ToastMaker.createToast(status.success, 'You successfully changed your address');
        setTimeout(() => {
          url.searchParams.delete('address_updated');
          window.history.replaceState({}, '', url.toString());
        }, timeout);
      }
      if (url.searchParams.has('address_added')) {
        ToastMaker.createToast(status.success, 'You successfully added a new address');
        setTimeout(() => {
          url.searchParams.delete('address_added');
          window.history.replaceState({}, '', url.toString());
        }, timeout);
      }
      if (url.searchParams.has('email_updated')) {
        const popup = document.querySelector('#emailUpdatedPopup');
        if (!popup) {
          return;
        }
        popup.open();
        setTimeout(() => {
          url.searchParams.delete('email_updated');
          window.history.replaceState({}, '', url.toString());
        }, timeout);
      }
    })();
  });

  document.addEventListener('dirty-form:form-submitted', () => {
    const dialogs = document.querySelectorAll('custom-dialog');
    dialogs.forEach(dialog => {
      dialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    if (params.has('password_recovered')) {
      const passwordResetSuccess = document.querySelector('#passwordResetSuccess');
      if (!passwordResetSuccess) return;
      passwordResetSuccess.classList.add('show');

      setTimeout(() => {
        params.delete('password_recovered');
        window.history.replaceState({}, '', url.toString());
      }, 5000);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
